import SideBar from "../Components/SideBar"
import { useState, useEffect } from "react";
import { getUserRequestByType } from "../Services/UserRequest";
import { useTranslation } from "react-i18next";
const AppCategories = () => {
    const [activeTab, setActiveTab] = useState(0);
    const {t} = useTranslation();
    const tabs = [
        { id: "cities", label: t("cities"), content: "City configs request", entry:t("Categories") },
        { id: "category", label: t("categoryTitle"), content: "Category configs request", entry:t("Categories") },
        { id: "services", label: t("serviceLabel"), content: "Category configs request", entry:t("Services") },
    ];
    const [cityList, setCityList] = useState();
    const [categoryList, setCategoryList] = useState();
    const [serviceList, setServiceList] = useState();
    useEffect(() => {
        getUserRequestByType("city").then((res) => {
            setCityList(res.data.data);
            console.info("Cities request fetched successfully", res.data.data);
        }).catch(e => {
            console.error("Error fetching cities request", e);
        });
        getUserRequestByType("category").then((res) => {
            setCategoryList(res.data.data);
            console.info("Category request fetched successfully", res.data.data);
        }).catch(e => {
            console.error("Error fetching category request", e);
        });
        getUserRequestByType("service").then((res) => {
            setServiceList(res.data.data);
            console.info("Services request fetched successfully", res.data.data);
        }).catch(e => {
            console.error("Error fetching services request", e);
        });
    }, []);
    const renderData = [cityList, categoryList, serviceList];
    return (
        <div className="bg-gray-800 body-font relative min-h-screen">
            <SideBar />
            <div className="container w-auto px-5 py-2 bg-gray-900">
                <div className="p-6 m-auto flex flex-col">
                    <h2 className="text-2xl font-bold text-white mt-6">{t("user_requests")}</h2>
                    <div className="space-y-4">
                        <div className="flex">
                            {tabs?.map((tab, index) => (
                                <button
                                    key={index}
                                    className={`px-4 py-2 font-medium text-md text-bold transition-all duration-200 ${activeTab === index
                                        ? "border-b-2 border-blue-500 text-blue-600"
                                        : "text-white hover:text-blue-500"
                                        }`}
                                    onClick={() => setActiveTab(index)}
                                >
                                    {tab.label}
                                </button>
                            ))}
                        </div>
                        <div className="p-4 bg-white border border-gray-200 rounded-b-md space-y-4">
                            <div className="overflow-x-auto">
                                <table className="table-auto w-full text-left border-collapse">
                                    <thead>
                                        <tr>
                                            <th className="border px-4 py-2">{t("username")}</th>
                                            <th className="border px-4 py-2">{t("email")}</th>
                                            <th className="border px-4 py-2">{tabs[activeTab].label}</th>
                                            <th className="border px-4 py-2">{t("descriptionLabel")}</th>
                                            <th className="border px-4 py-2">{t("status")}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {renderData[activeTab]?.map((item, index) => (
                                            <tr key={index} className="hover:bg-gray-100">
                                                <td className="border px-4 py-2">{item.userName}</td>
                                                <td className="border px-4 py-2">{item.userEmail}</td>
                                                <td className="border px-4 py-2">{item.requestName}</td>
                                                <td className="border px-4 py-2">{item.description}</td>
                                                <td className="border px-4 py-2">{t(`${item.status.toLowerCase()}`)}</td>                    
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
                <div>
                </div>
            </div>
        </div>
    )
}

export default AppCategories;